import uniqWith from 'lodash/uniqWith';
import React from 'react';

import { useForumPosts } from '@hooks';

import ForumPostList from '../ForumPostList';
import TopicPostAuthors from './TopicPostAuthors';

interface TopicPostsProps {
  topic: string;
}

const TopicPosts = ({ topic }: TopicPostsProps) => {
  const { forumPosts, areForumPostsLoading } = useForumPosts({
    perPage: 3,
    topic: topic.toLowerCase(),
  });

  const uniqAuthors = uniqWith(forumPosts, (x, y) => x.comment.user.id === y.comment.user.id)
    .slice(0, 3)
    .map((post) => post.comment.user);

  return (
    <>
      {!areForumPostsLoading && (
        <>
          {forumPosts?.length > 0 && (
            <div className="container-full topic-forum-container">
              <div className="container">
                <div className="row">
                  <div className="col-xs-12">
                    <div className="landing-page-section-container">
                      <div className="landing-page-section-title--topic">
                        <a id="subscriber-posts" className="subscriber-posts">
                          Subscriber posts about <strong>{topic}</strong>
                        </a>
                      </div>
                      {uniqAuthors?.length > 0 && <TopicPostAuthors authors={uniqAuthors} />}
                      <ForumPostList forumPosts={forumPosts} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default TopicPosts;
